
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

export class GenRoleDefinition {
    static readonly ROLE_GDO: GenRoleDefinition = new GenRoleDefinition('ROLE_GDO');
    static readonly ROLE_USER_MANAGER: GenRoleDefinition = new GenRoleDefinition('ROLE_USER_MANAGER');
    static readonly ROLE_DOE: GenRoleDefinition = new GenRoleDefinition('ROLE_DOE');
    static readonly ROLE_STATE_USER: GenRoleDefinition = new GenRoleDefinition('ROLE_STATE_USER');
    static readonly ROLE_ADMIN: GenRoleDefinition = new GenRoleDefinition('ROLE_ADMIN');
    static readonly ROLE_APPLICATION_MANAGER: GenRoleDefinition = new GenRoleDefinition('ROLE_APPLICATION_MANAGER');
    static readonly ROLE_APPROVED_USER: GenRoleDefinition = new GenRoleDefinition('ROLE_APPROVED_USER');
    static readonly ROLE_RESETTING_PASSWORD: GenRoleDefinition = new GenRoleDefinition('ROLE_RESETTING_PASSWORD');

    public readonly name: string;

    private constructor(name: string) {
        this.name = name;
    }

    static forName(name: string) {
        if (name === 'ROLE_GDO') return GenRoleDefinition.ROLE_GDO;
        if (name === 'ROLE_USER_MANAGER') return GenRoleDefinition.ROLE_USER_MANAGER;
        if (name === 'ROLE_DOE') return GenRoleDefinition.ROLE_DOE;
        if (name === 'ROLE_STATE_USER') return GenRoleDefinition.ROLE_STATE_USER;
        if (name === 'ROLE_ADMIN') return GenRoleDefinition.ROLE_ADMIN;
        if (name === 'ROLE_APPLICATION_MANAGER') return GenRoleDefinition.ROLE_APPLICATION_MANAGER;
        if (name === 'ROLE_APPROVED_USER') return GenRoleDefinition.ROLE_APPROVED_USER;
        if (name === 'ROLE_RESETTING_PASSWORD') return GenRoleDefinition.ROLE_RESETTING_PASSWORD;
        throw new Error('Unexpected value for GenRoleDefinition:' + name);
    }

    static values(): GenRoleDefinition[] {
        return [
            GenRoleDefinition.ROLE_GDO,
            GenRoleDefinition.ROLE_USER_MANAGER,
            GenRoleDefinition.ROLE_DOE,
            GenRoleDefinition.ROLE_STATE_USER,
            GenRoleDefinition.ROLE_ADMIN,
            GenRoleDefinition.ROLE_APPLICATION_MANAGER,
            GenRoleDefinition.ROLE_APPROVED_USER,
            GenRoleDefinition.ROLE_RESETTING_PASSWORD,
        ];
    }

    toJSON(): string {
        return this.name;
    }

    toString(): string {
        return this.name;
    }
}

